/**
 * React component for RadioGroup.
 * @module src/components/Shared/RadioGroup
 */
import React, { FC } from 'react';
import Radio from '@salesforce/design-system-react/components/radio-group/radio';

interface Props {
  handleRadioButtonChange: (event: any, type: any) => void;
  defaultValue: any;
  label: string;
  items: { label: string; id: string; value?: any }[];
  disabled?: boolean;
  required?: boolean;
}

const RadioGroup: FC<Props> = props => {
  const { handleRadioButtonChange, defaultValue, label, items, disabled, required } = props;
  return (
    <div
      className="slds-grid"
      style={{ justifyContent: 'space-between' }}
    >
      <span className="slds-text-body_small slds-text-title_bold">
        {required && <span style={{ color: '#c23934' }}>* </span>}
        {label}
      </span>
      <div className="slds-grid">
        {items &&
          items.map((item: any) => (
            <div style={{ marginRight: '30px' }}>
              <Radio
                className="radio-group"
                key={item.label}
                id={item.id}
                onChange={(event: { target: { value: any } }) =>
                  handleRadioButtonChange(event, 'accounts')
                }
                labels={{
                  label: item.label,
                }}
                value={item.label}
                checked={defaultValue === item.label}
                variant="base"
                size="large"
                disabled={disabled}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default RadioGroup;
